import { JsonObject, JsonProperty } from 'json2typescript';

import { AbstractEntity } from '../abstract-entity/abstract-entity';
import { LearnCertClassDTO } from './learn-cert-class-dto';
import { LearnCertClass } from './learn-cert-class';
import { LearnCertType } from './learn-cert-type';
import { LearnCertEntry } from './learn-cert-entry';


@JsonObject
export class LearnCert extends AbstractEntity {
  @JsonProperty('entries', [LearnCertEntry], true)
  entries: LearnCertEntry[] = [];

  resetEntries(learnCertClassDTOs: LearnCertClassDTO[]) {
    learnCertClassDTOs = learnCertClassDTOs || [];
    this.entries.forEach(entry => {
      let dto = this.getClassByClassId(learnCertClassDTOs, entry.classId);
      if (dto) {
        entry.learnCertClass = dto.learnCertClass;
        entry.learnCertType = dto.getTypeById(entry.typeId);
      } else {
        entry.learnCertClass = new LearnCertClass();
        entry.learnCertType = new LearnCertType();
      }
    });
  }

  resetEntriesByLearnCertClass(learnCertClasses: LearnCertClass[]) {
    learnCertClasses = learnCertClasses || [];
    this.entries.forEach(entry => {
      let classItem = LearnCertClass.findClassByClassId(entry.classId, learnCertClasses);
      if (classItem) {
        entry.learnCertClass = classItem;
        entry.learnCertType = classItem.getLearnCertTypeByTypeId(entry.typeId);
      } else {
        entry.learnCertClass = new LearnCertClass();
        entry.learnCertType = new LearnCertType();
      }
    });
  }

  private getClassByClassId(learnCertClassDTOs: LearnCertClassDTO[], classId: number): LearnCertClassDTO {
    learnCertClassDTOs = learnCertClassDTOs || [];
    return learnCertClassDTOs.filter(dto => dto.learnCertClass.id === classId)[0];
  }
}
